(function () {
  function closeAll(except) {
    document.querySelectorAll('[data-quick-chip][open]').forEach(function (chip) {
      if (chip !== except) chip.removeAttribute('open');
    });
  }

  function init() {
    document.querySelectorAll('[data-quick-chip]').forEach(function (chip) {
      if (chip.dataset.chipBound) return;
      chip.dataset.chipBound = '1';
      chip.addEventListener('toggle', function () {
        if (chip.open) closeAll(chip);
      });
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-quick-chip]')) closeAll(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
